import { urlPathnameToLocationName } from '@/features/shared/analytics/utils'
import { AnalyticsEvent } from '@shipt/analytics-member-web'
import { track } from '@/features/shared/analytics/trackingQueue'

type Args = {
  storeId: number
  storeName: string
  storeLocationId?: number
  isNew?: boolean
  index: number
  displaySublocation?: string
  promotionId?: number
  openCart?: boolean
  content?: string
  attributes?: string[]
  availableAttributes?: string[]
  promos?: number[]
}

export const trackAvailableStoreViewed = ({
  storeId,
  storeName,
  storeLocationId,
  isNew,
  index,
  displaySublocation,
  promotionId,
  openCart,
  attributes,
  availableAttributes,
  promos,
}: Args) => {
  track({
    eventName: AnalyticsEvent.AvailableStoreViewed,
    properties: {
      store_id: storeId,
      store_name: storeName,
      store_location_id: storeLocationId,
      is_new: isNew,
      location: urlPathnameToLocationName(),
      index,
      display_sublocation: displaySublocation,
      promotion_id: promotionId,
      open_cart: openCart,
      attributes,
      available_attributes: availableAttributes,
      promos,
    },
  })
}

export const trackAvailableStoreClicked = ({
  storeId,
  storeName,
  storeLocationId,
  isNew,
  index,
  displaySublocation,
  promotionId,
  openCart,
  content,
  attributes,
  availableAttributes,
  promos,
}: Args) => {
  track({
    eventName: AnalyticsEvent.AvailableStoreClicked,
    properties: {
      store_id: storeId,
      store_name: storeName,
      store_location_id: storeLocationId,
      is_new: isNew,
      location: urlPathnameToLocationName(),
      index,
      display_sublocation: displaySublocation,
      promotion_id: promotionId,
      open_cart: openCart,
      ...(content && { content }),
      attributes,
      available_attributes: availableAttributes,
      promos,
    },
  })
}
